import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink, BookOpen } from "lucide-react";
import PortalBottomNav from "../components/PortalBottomNav";
import PortalHeader from "../components/PortalHeader";

const DRIVE_FOLDER_ID = "1SfLV9zeENKrOQqtbLZuhoh_xBRsCu1h7";
const DRIVE_EMBED_URL = `https://drive.google.com/embeddedfolderview?id=${DRIVE_FOLDER_ID}#list`;
const DRIVE_OPEN_URL = `https://drive.google.com/drive/folders/${DRIVE_FOLDER_ID}`;

const SaviLibraryPage = () => {
  return (
    <div className="min-h-screen bg-[#FBF7F1] pb-24 savi-bg-pattern" data-testid="savi-library-page">
      <PortalHeader title="Library" back="/guide" testid="library-header" />
      <div className="max-w-3xl mx-auto px-4 pt-5">
        <p className="text-sm text-[#1A1A1A]/60">Shared reads, recipes and resources — curated by the Savi community.</p>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-4 space-y-3">
        {/* Open-in-Drive button — fallback for iOS Safari that occasionally
            refuses to render embedded Drive frames. */}
        <div className="flex items-center justify-between bg-white rounded-2xl px-4 py-3 border border-stone-100">
          <div className="text-xs text-[#3D4035]/70">
            Trouble seeing files below? Open the folder directly.
          </div>
          <a
            href={DRIVE_OPEN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-[#C85A38] hover:text-[#A84830]"
            data-testid="library-open-drive"
          >
            <span>Open in Drive</span>
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>

        {/* Embedded Drive folder view */}
        <div className="bg-white rounded-2xl overflow-hidden border border-stone-100">
          <iframe
            src={DRIVE_EMBED_URL}
            title="Savi Library folder"
            className="w-full h-[70vh] min-h-[500px] block"
            frameBorder="0"
            data-testid="library-iframe"
          />
        </div>

        {/* Contribute — suggest additions to the library */}
        <a
          href="mailto:hola@savicoliving.com?subject=Savi%20Library%20suggestion&body=Hi%20Steve%2C%0A%0AI%27d%20love%20to%20add%20this%20to%20the%20Savi%20Library%3A%0A%0A-%20Title%3A%0A-%20Link%20or%20file%3A%0A-%20Why%20it%27s%20great%3A%0A%0AThanks%21"
          className="flex items-center justify-between bg-[#F3F5EF] rounded-2xl px-4 py-3 border border-[#8C9A7C]/30 hover:bg-[#E8EDE0] transition-colors"
          data-testid="library-contribute"
        >
          <div className="flex-1">
            <p className="text-sm font-medium text-[#3D4035]">Got a great read, recipe or link?</p>
            <p className="text-xs text-[#3D4035]/60 mt-0.5">Tap to email your suggestion — we'll add it to the library.</p>
          </div>
          <ExternalLink className="w-4 h-4 text-[#5C6A4C] flex-shrink-0" />
        </a>

        <p className="text-[11px] text-[#3D4035]/50 text-center pt-2">
          Tap a file to open it in a new tab. Downloads and previews are handled by Google Drive.
        </p>
      </div>
      <PortalBottomNav />
    </div>
  );
};

export default SaviLibraryPage;
